import { gsap } from "gsap";
/* The following plugin is a Club GSAP perk */
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText, ScrollTrigger);

// Sélection des quotes une seule fois
const quotes = gsap.utils.toArray(".quote");

function createSplits() {
    quotes.forEach((quote) => {
        // Reset si déjà animé
        if (quote.anim) {
            quote.anim.progress(1).kill();
            quote.anim = null;
        }
        if (quote.split) {
            quote.split.revert();
            quote.split = null;
        }

        // Split uniquement en desktop
        quote.split = new SplitText(quote, {
            type: "lines,words,chars",
            linesClass: "split-line",
        });

        quote.anim = gsap.from(quote.split.chars, {
            scrollTrigger: {
                trigger: quote,
                toggleActions: "restart none restart none",
                start: "center center",
                markers: false,
            },
            duration: 0.6,
            ease: "circ.out",
            y: 80,
            stagger: 0.02,
        });
    });
}

function revertSplits() {
    quotes.forEach((quote) => {
        if (quote.anim) {
            quote.anim.kill();
            quote.anim = null;
        }
        if (quote.split) {
            quote.split.revert();
            quote.split = null;
        }
    });
}

// Responsive : on n’active l’effet que >= 992px
ScrollTrigger.matchMedia({
    // Desktop et plus : min-width 992px (Bootstrap lg)
    "(min-width: 992px)": function () {
        createSplits();
        ScrollTrigger.addEventListener("refresh", createSplits);

        // Cleanup si on quitte cette condition (passage < 992px)
        return () => {
            ScrollTrigger.removeEventListener("refresh", createSplits);
            revertSplits();
        };
    },

    // En dessous de 992px : on s’assure qu’il n’y a PLUS d’effet
    "(max-width: 991px)": function () {
        revertSplits();
    },
});





// Top bar text marquee

function initTopbarSingleTicker() {
    const bars = gsap.utils.toArray(".pdw-topbar-marquee");
    if (!bars.length) return;

    bars.forEach((bar) => {
        const inner = bar.querySelector(".pdw-topbar-inner");
        const item  = bar.querySelector(".pdw-topbar-item");
        if (!inner || !item) return;

        if (bar._tickerCleanup) bar._tickerCleanup();

        const speed = parseFloat(bar.dataset.speed || "120"); // px/s
        const pad = 16;

        let tween = null;
        let lastW = 0;

        const setup = () => {
            const innerW = Math.round(inner.getBoundingClientRect().width);
            const itemW  = Math.round(item.getBoundingClientRect().width);
            if (!innerW || !itemW) return;

            lastW = innerW;

            // Si tween existe, on le tue proprement (on évite les doublons)
            if (tween) tween.kill();

            // départ à droite (dans le container)
            gsap.set(item, { x: innerW - pad });

            const distance = (innerW - pad) + itemW;
            const duration = distance / Math.max(20, speed);

            tween = gsap.to(item, {
                x: -(itemW - pad),
                duration,
                ease: "none",
                repeat: -1,
                onRepeat: () => gsap.set(item, { x: innerW - pad }),
            });
        };

        setup();

        // ✅ Ignorer les "resize" liés au scroll (barre d’adresse) : on ne réinit que si la largeur change
        let t;
        const onResize = () => {
            clearTimeout(t);
            t = setTimeout(() => {
                const w = Math.round(inner.getBoundingClientRect().width);
                if (!w) return;
                if (Math.abs(w - lastW) < 2) return; // largeur quasi identique => on ne reset pas
                setup();
            }, 150);
        };

        window.addEventListener("resize", onResize);

        bar._tickerCleanup = () => {
            window.removeEventListener("resize", onResize);
            if (tween) tween.kill();
            tween = null;
            delete bar._tickerCleanup;
        };
    });
}

document.addEventListener("DOMContentLoaded", initTopbarSingleTicker);